/** Maps the numeric image privacy level (0/1/2) to the notificationAiPrivacyLevel value. */
export const PRIVACY_LEVEL_VALUES: Record<number, string> = {
  0: "no_blur",
  1: "face_blur",
  2: "body_blur",
};

export const privacyLevelValue = (level: number): string =>
  PRIVACY_LEVEL_VALUES[level] ?? "face_blur";

/** Ordered BuildShip updateDevice calls for a privacy level change. */
export const buildPrivacyUpdates = (level: number): [string, string | number][] => [
  ["devicePrivacyLevel", level],
  ["notificationAiPrivacyLevel", privacyLevelValue(level)],
];
